import { Link } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

export function HomePage() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="page home-page">
      <section className="hero">
        <h2>Precision in Every Serving</h2>
        <p className="hero-subtitle">
          Eliminate the guesswork from cannabis-infused cooking. Calculate precise per-serving
          dosages, manage recipes, and track your experiences — all in one place.
        </p>
        {isAuthenticated ? (
          <Link to="/dashboard" className="cta-button">
            Go to Dashboard
          </Link>
        ) : (
          <div className="cta-group">
            <Link to="/signup" className="cta-button">
              Start Free
            </Link>
            <Link to="/login" className="cta-button-secondary">
              Sign In
            </Link>
          </div>
        )}
      </section>

      <section className="features">
        <h3>Built for Precision</h3>
        <div className="feature-grid">
          <div className="feature-card">
            <h4>Dosing Calculator</h4>
            <p>
              Multi-cannabinoid calculations with decarboxylation modeling and extraction
              efficiency for THC, CBD, CBN, CBG, and more.
            </p>
          </div>
          <div className="feature-card">
            <h4>Recipe Builder</h4>
            <p>
              Create, version, and manage infused recipes with automatic potency tracking
              across modifications.
            </p>
          </div>
          <div className="feature-card">
            <h4>Ingredient Library</h4>
            <p>
              Pre-built strain profiles and concentrate databases with lab-verified cannabinoid
              data.
            </p>
          </div>
          <div className="feature-card">
            <h4>Dosing Journal</h4>
            <p>
              Track consumption, effects, and build your personal tolerance profile over time.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
